import { Mixpanel } from '../services/Mixpanel';
import { GET_PREMIUM_ACCESS_URL } from './isPremiumUser';

/** Track the click and open the plans page; `location` names the quota surface it came from. */
export const openQuotaUpgrade = (location, quota) => {
  Mixpanel.track('Project Quota Upgrade Clicked', {
    location,
    remaining: quota?.remaining,
    limit: quota?.limit,
  });
  window.open(GET_PREMIUM_ACCESS_URL, '_blank');
};
